import {
  type CreateOrUpdateRewardCommand,
  postRewards,
  type RewardData,
} from "Infrastructure/Api/Api.ts";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RewardKeys, rewardMutationKeys } from "./rewardKeys";

export const useCreateOrUpdateRewardMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<RewardData, Error, CreateOrUpdateRewardCommand>({
    mutationKey: rewardMutationKeys.createOrUpdate,
    mutationFn: processResponse((command) => postRewards(command)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: RewardKeys.lists() });
    },
  });
};
